// extracted by mini-css-extract-plugin
export default {"button":"RCC0B"};